import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ComponentName,
  ConfirmationType,
  ControlType,
  HeaderFilter,
  ModuleName,
  Modules,
  NotificationDetails,
  NotificationHeader,
  NotificationTextMessage,
  RoutingPath,
  VatSettings,
} from '@app/core/Enum';
import {
  ExportType,
  GlobalComponent,
  HeaderModel,
  MainListParameters,
} from '@app/core/Models';
import {
  BankDasboardService,
  CommonService,
  ModulePermission,
  NotificationService,
} from '@app/core/Services';
import {
  BankOverviewState,
  CheckVatNumber,
  CommonState,
  CreateCustomAccount,
  DonationState,
  GetActivityList,
  GetHeaderList,
  MenuState,
  RefreshAccountProductionTrialBalance,
  SetDefaultVatId,
} from '@app/core/Store';
import {
  DepreciationExpandedCollapseComponent,
  ShareComponent,
} from '@app/modules';
import { BankLinkComponent } from '@app/modules/bank';
import { QuickJournalComponent } from '@app/modules/bank/quick-journal/quick-journal.component';
import {
  AddClosePopupComponent,
  ConfirmationBoxComponent,
  QuickAddComponent,
} from '@app/modules/common';
import CustomYearPickerComponent from '@app/modules/custom/custom-year-picker/custom-year-picker.component';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SideListModel } from '@app/core/Models';

@Component({
  selector: 'app-transactions-header',
  templateUrl: './transactions-header.component.html',
  styleUrls: ['./transactions-header.component.scss'],
})
export class TransactionHeaderComponent implements OnInit, OnDestroy, OnChanges {
  defaultValue: any[] = [
    { id: -1 },
    { id: -1 },
    { id: -1 },
    { id: -1 },
    { id: -1 },
  ];

  isTrialBalanceImported = false;
  isAccountProductionTrialBalance = false;
  isManualTrialBalance = false;
  accoutingPeriodId = Guid.EMPTY as unknown as Guid;

  @Output()
  readonly triggerDataFromHeader = new EventEmitter<any>();

  @Output()
  readonly triggerQuickAdd = new EventEmitter<any>();

  @Input() listParameters: any;

  @Input() showAccountDetails: boolean = false;

  @Input() isBankImport: boolean = false;
  @Input() noDataFound:boolean=false;

  @Input() customId: any;
  @Input() dataSource:any;
  @Input() transactionModuleId: number;

  @Select(MenuState.hasAddPermission)
  hasAddPermission$: Observable<boolean>;

  @Select(MenuState.moduleId)
  moduleId$: Observable<number>;

  @Select(MenuState.menu)
  menu$: Observable<any>;

  @Select(MenuState.moduleName)
  moduleName$: Observable<string>;

  @Select(CommonState.totalRecord)
  totalRecord$: Observable<number>;

  @Select(BankOverviewState.totalRecord)
  totalBankOverviewRecord$: Observable<number>;

  controlType = ControlType;
  periodicDateList: any;

  @Select(CommonState.headerList)
  headerList$: Observable<Array<HeaderModel>>;

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;

  customDate = false;
  headerList: any;

  HeaderFilters = HeaderFilter;
  moduleEnum = Modules;
  moduleId: number;
  headerData: MainListParameters = new MainListParameters();
  exportType = ExportType;
  modules = Modules;
  periodicId = '-1';
  moduleName = '';
  searchText = '';
  accountId: any = null;
  isRowHighlighted: boolean = false;
  accountGroupList: any[] = [];
  activityList: SideListModel[] = [];
  selectedActivity: string = '';

  private _moduleIdSubscription;

  subscriptionRouting: Subscription;

  commonService: CommonService;
  store: Store;
  modulePermission: ModulePermission;
  router: Router;
  bankDasboardService: BankDasboardService;
  dialog: MatDialog;
  globalComponent: GlobalComponent;
  _Activatedroute: ActivatedRoute;
  notify: NotificationService;
  sendMailParamsRequest: any;

  datepipe: DatePipe;

  @ViewChild(CustomYearPickerComponent, { static: true })
  customYearPickerComponent;

  private unsubscribe$ = new Subject<void>();

  isSponserEventChangePermission: boolean = true;
  isFundChangePermission: boolean = true;
  isActivityChangePermission: boolean = true;
  isDonorChangePermission: boolean = true;
  isJournalChangePermission: boolean = true;
  isImportChangePermission: boolean = true;
  showCloseIcon: boolean = false;
  isShowImportFromBookkeeping = localStorage.getItem('isShowBookkeeping') === 'true';
  constructor(private injector: Injector, private spinner: NgxSpinnerService) {
    this._Activatedroute = injector.get<ActivatedRoute>(ActivatedRoute);
    this.store = injector.get<Store>(Store);
    this.commonService = injector.get<CommonService>(CommonService);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.modulePermission = injector.get<ModulePermission>(ModulePermission);
    this.router = injector.get<Router>(Router);
    this.bankDasboardService =
      injector.get<BankDasboardService>(BankDasboardService);
    this.globalComponent = injector.get<GlobalComponent>(GlobalComponent);
    this.notify = injector.get<NotificationService>(NotificationService);
    this.datepipe = injector.get<DatePipe>(DatePipe);
  }

  ngOnInit(): void {
    const currentUrl = this._Activatedroute.snapshot['_routerState'].url;

    // SHOW CLOSE ICON ONLY WHEN URL CONTAINS bankTransaction
    if (currentUrl.includes('bankTransaction')) {
      this.showCloseIcon = true;
    } else {
      this.showCloseIcon = false;
    }
    this.periodicDateList = this.globalComponent.getFinancialPeriod();
    this.getActivityList();

    if (
      !this.isBankImport &&
      this.transactionModuleId !== Modules.BankImportTransactionHistory
    ) {
      this.modulePermission.permissionData
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((value) => {
          if (!value || !value.data) {
            return;
          }

          this.moduleId = value.data.id;

          if (
            this.moduleId !== Modules.CharityProfile &&
            this.moduleId !== Modules.Dashboard
          ) {
            if (
              (value.data.url === this.router.url.slice(1) ||
                value.data.url === this.router.url.slice(1).split(';')[0]) &&
              (value.componentName === ComponentName.MainListComponent ||
                value.componentName ===
                  ComponentName.BankReconciliationComponent ||
                value.componentName === ComponentName.ImportListComponent ||
                value.componentName === ComponentName.ReportListComponent ||
                value.componentName === ComponentName.NominalLedgerComponent ||
                value.componentName === ComponentName.BulkEdit ||
                value.componentName === ComponentName.VatSettings ||
                value.componentName === ComponentName.BankOverviewComponent ||
                value.componentName === ComponentName.BankFeedComponent ||
                value.componentName === ComponentName.CashCodingComponent ||
                value.componentName ===
                  ComponentName.ReportCreditorDebtorComponent ||
                value.componentName ===
                  ComponentName.ReportListWithActionsComponent)
            ) {
              this.store
                .dispatch(new GetHeaderList(value.data.id))
                .subscribe((data) => {
                  this.headerList = data.common.headerList;
                  this.headerList.forEach((item) => {
                    if (item.value.length > 0) {
                      this.commonService.defaultHeaderGuidValue =
                        this.commonService.setParamId !== null &&
                        this.commonService.setParamId !== undefined
                          ? this.commonService.setParamId
                          : item.value[0].id;

                      this.setDataFortheHeaderParamters(
                        item.name,
                        this.commonService.defaultHeaderGuidValue
                      );

                      if (item.name === HeaderFilter.Module) {
                        this.headerData.moduleId =
                          this.commonService.defaultHeaderGuidValue;
                      }
                    }

                    if (item.groupValue.length > 0) {
                      this.accountGroupList = this.addGroupNameToListModels(
                        item.groupValue
                      );

                      this.commonService.defaultHeaderGuidValue =
                        this.commonService.setParamId !== null &&
                        this.commonService.setParamId !== undefined
                          ? this.commonService.setParamId
                          : this.accountGroupList[0].id;

                      this.onDropdownChange(
                        item.name,
                        this.commonService.defaultHeaderGuidValue,
                        false
                      );
                    }
                  });

                  if (
                    this.moduleId !== Modules.TrialBalance &&
                    this.moduleId !== Modules.BalanceSheet &&
                    this.moduleId !== Modules.StatementofFinancialActivities &&
                    this.moduleId !== Modules.IncomeAndExpenditure &&
                    this.moduleId !== Modules.PurchaseDayBook &&
                    this.moduleId !== Modules.SalesDayBook &&
                    this.moduleId !== Modules.AccountDetails
                  ) {
                    this.dataChangeFromHeader(false);
                  }
                });
            }
          }
        });

      this.customDate = false;
      this.moduleName$.subscribe((x) => {
        this.moduleName =
          x.toLocaleLowerCase() === VatSettings.VatSettings.toLocaleLowerCase()
            ? VatSettings.VatCodes[VatSettings.VatCodes.length - 1] === 's'
              ? VatSettings.VatCodes.substring(
                  0,
                  VatSettings.VatCodes.length - 1
                )
              : VatSettings.VatCodes
            : x[x.length - 1] === 's'
            ? x.substring(0, x.length - 1)
            : x;
      });

      this.subscriptionRouting = this._Activatedroute.paramMap.subscribe(
        (params) => {
          const currentUrl = this._Activatedroute.snapshot['_routerState'].url;
          if (currentUrl.includes('bank/cashEntry')) {
            this.moduleId = Modules.CashEntry;
            this.getHeader();
          }

          if (params.keys.length > 0) {
            this.commonService.setParamId = atob(
              params.get('id')!
            ) as unknown as any;
          } else {
            this.commonService.setParamId = null;
          }
        }
      );
    } else if (this.isBankImport) {
      this.moduleId = Modules.BankImportHistory;
      this.getHeader();
    } else if (
      (this.transactionModuleId = Modules.BankImportTransactionHistory)
    ) {
      this.moduleId = Modules.BankImportTransactionHistory;
      this.getHeader();
      this.dataChangeFromHeader(false);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isSponserEventChangePermission = this.commonService.checkPermission(
        Modules.Tasks,
        Modules.SponsorEvent
      );
      this.isFundChangePermission = this.commonService.checkPermission(
        Modules.Funds,
        Modules.FundList
      );
      this.isActivityChangePermission = this.commonService.checkPermission(
        Modules.Tasks,
        Modules.Activities
      );
      this.isDonorChangePermission = this.commonService.checkPermission(
        Modules.Contacts,
        Modules.Donors
      );
      this.isJournalChangePermission = this.commonService.checkPermission(
        Modules.Tasks,
        Modules.Journals
      );
      this.isImportChangePermission = this.commonService.checkPermission(
        Modules.Manage,
        Modules.Import
      );
    }, 3000);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getActivityList(): void {
    this.store
      .dispatch(new GetActivityList())
      .subscribe(() => {
        this.activityList = this.store.selectSnapshot(DonationState.getActivity);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.noDataFound && this.moduleId === Modules.AccountProductionTrialBalance) {
      // If there is no data after a delete and the UI shows noDataFound,
      // ensure manual flag is reset so the header shows the Manual action.
      if (this.noDataFound && (!this.dataSource || this.dataSource?.data?.length === 0) && localStorage.getItem('isJournalEmpty') === 'true') {
        this.isManualTrialBalance = false;

        // Also update session financial period flag so year-picker reflects state
        try {
          const yearList = this.globalComponent.getFinancialPeriod();
          const defaultFinancialPeriod = localStorage.getItem('defaultFinancialPeriod');
          if (defaultFinancialPeriod) {
            yearList.forEach((element: any) => {
              if (element['name'] === defaultFinancialPeriod) {
                element['isManualTrialBalance'] = false;
              }
            });
            this.commonService.setLocalStorage('financialPeriod', JSON.stringify(yearList));
          }
        } catch (e) {
          // swallow errors to avoid breaking UI
          console.error('Error updating financial period in local storage', e);
        }
      }
    }
  }

  getHeader(): void {
    if (
      this.moduleId !== Modules.Dashboard &&
      this.moduleId !== Modules.IncomeOverview &&
      this.moduleId !== Modules.ExpenditureOverview &&
      this.moduleId !== Modules.FixedAssetOverview
    ) {
      this.store.dispatch(new GetHeaderList(this.moduleId));
    }
  }

  onAddClick(): void {
    this.commonService.toggleMenu = false;
    this.commonService.isInitialValueChange = false;
    this._moduleIdSubscription = this.moduleId$.subscribe((data: any) => {
      if (
        data !== Modules.BankDashboard &&
        data !== Modules.BankFeed &&
        data !== Modules.FixedAssetsRegister
      ) {
        this.commonService.onAddRouting(data);
      } else if (data === Modules.BankDashboard) {
        this.gotoAddCustomAccount();
      } else if (data === Modules.FixedAssetsRegister) {
        const mainListData = this.store.selectSnapshot(CommonState.mainListData);
        const hasExplainedRecord = mainListData.some(
          (row: any[]) => row[5]?.rowData?.toLowerCase() === 'true'
        );
        if (!hasExplainedRecord) {
          this.commonService.onFailure(
            NotificationTextMessage.explainBeforeDepreciation
          );
          return;
        }
        this.dialog
          .open(DepreciationExpandedCollapseComponent, {
             data: {
              moduleId: this.transactionModuleId,
            },
          disableClose: true,
            panelClass: 'depreciation-list-dialog',
          })
          .afterClosed()
          .subscribe(() => {
            this.dataChangeFromHeader(false);
          });
      } else {
        this.dialog
          .open(BankLinkComponent)
          .afterClosed()
          .subscribe(() => {});
      }
    });
    this._moduleIdSubscription.unsubscribe();
  }

  onRefereshClick(): void {
    const selectedPeriod = this.periodicDateList?.find(
      (x) => x.id === this.accoutingPeriodId
    );

    if (selectedPeriod?.isLocked) {
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.accountingPeriodLocked
      );
      return;
    }
    
    let totalRecordOfRecords = 0;
    let response;
    this.commonService.toggleMenu = false;
    this.commonService.isInitialValueChange = false;
    this.totalRecord$.subscribe((x) => {
      totalRecordOfRecords = x;
    });
    if (totalRecordOfRecords > 0) {
      this.dialog
        .open(ConfirmationBoxComponent, {
          data: {
            type: ConfirmationType.RefreshTrialBalance,
            moduleId: Modules.AccountProductionTrialBalance,
            headerText: NotificationHeader.trialBalanceReferesh,
            detailText: NotificationDetails.trialBalanceReferesh,
          },
        })
        .afterClosed()
        .subscribe((result) => {
          if (
            result &&
            this.accoutingPeriodId !== undefined &&
            this.accoutingPeriodId !== null &&
            this.accoutingPeriodId !== (Guid.EMPTY as unknown as Guid)
          ) {
            this.spinner.show(); 
            this.store
              .dispatch(
                new RefreshAccountProductionTrialBalance(this.accoutingPeriodId)
              )
              .subscribe((res: any) => {
                response = res.accountProduction.refreshTrialBalance;
                if (response.isSuccess) {
                  this.notify.success(
                    NotificationHeader.success,
                    NotificationTextMessage.trialBalanceRefereshSuccessfully
                  );
                  this.isManualTrialBalance = false;
                  this.isAccountProductionTrialBalance = false;
                  this.isTrialBalanceImported = false;
                  const yearList = this.globalComponent.getFinancialPeriod();
                  const defaultFinancialPeriod = localStorage.getItem('defaultFinancialPeriod');
                  if (defaultFinancialPeriod) {
                    yearList.forEach((element: any) => {
                      if (element['name'] === defaultFinancialPeriod) {
                        element['isManualTrialBalance'] = false;
                        element['isTrialBalanceImported'] = false;
                        element['isAccountProductionTrialBalance'] = false;
                      }
                    });
                    this.commonService.setLocalStorage(
                      'financialPeriod',
                      JSON.stringify(yearList)
                    );
                  }
                  this.dataChangeFromHeader(false);
                } else {
                  this.notify.error(
                    NotificationHeader.error,
                    response?.statusMessage
                  );
                }
              });
          }
        });
    } else {
      if (
        this.accoutingPeriodId !== undefined &&
        this.accoutingPeriodId !== null &&
        this.accoutingPeriodId !== (Guid.EMPTY as unknown as Guid)
      ) {
        this.spinner.show(); 
        this.store
          .dispatch(
            new RefreshAccountProductionTrialBalance(this.accoutingPeriodId)
          )
          .subscribe((res: any) => {
            response = res.accountProduction.refreshTrialBalance;

            if (response.isSuccess) {
              this.notify.success(
                NotificationHeader.success,
                NotificationTextMessage.trialBalanceRefereshSuccessfully
              );
              this.isManualTrialBalance = false;
              this.isAccountProductionTrialBalance = false;
              this.isTrialBalanceImported = false;
              const yearList = this.globalComponent.getFinancialPeriod();
              const defaultFinancialPeriod = localStorage.getItem('defaultFinancialPeriod');
              if (defaultFinancialPeriod) {
                yearList.forEach((element: any) => {
                  if (element['name'] === defaultFinancialPeriod) {
                    element['isManualTrialBalance'] = false;
                    element['isTrialBalanceImported'] = false;
                    element['isAccountProductionTrialBalance'] = false;
                  }
                });
                this.commonService.setLocalStorage(
                  'financialPeriod',
                  JSON.stringify(yearList)
                );
              }
              this.dataChangeFromHeader(false);
            } else {
              this.notify.error(
                NotificationHeader.error,
                response?.statusMessage
              );
            }
          });
      }
    }
  }

  gotoAddCustomAccount(): void {
    this.dialog
      .open(QuickAddComponent, {
        disableClose: true,
        data: {
          moduleId: Modules.AddCustomAccounts,
          headerText: `Add ${ModuleName.AddCustomAccounts}`,
          saveActionName: CreateCustomAccount,
        },
      })
      .afterClosed()
      .subscribe((id) => {
        if (!this.commonService.isEmpty(id)) {
          this.triggerQuickAdd.emit(true);
        }
      });
  }

  checkVatNumber(data: any): void {
    this.store.dispatch(new CheckVatNumber()).subscribe((res) => {
      if (res.submitVat.checkVatNumber) {
        this.commonService.onAddRouting(data);
      } else {
        this.commonService.onFailure(NotificationTextMessage.checkVatNumber);
      }
    });
  }

  dataChangeFromHeader(onLoad: boolean): void {
    const params = {
      startDate: this.headerData.startDate,
      endDate: this.headerData.endDate,
      search: this.headerData.search,
      moduleId: this.headerData.moduleId,
      subModuleId: this.headerData.subModuleId,
      activityId: this.headerData.activityId,
      format: this.headerData.format,
      isPrint: this.headerData.isPrint,
      filter: this.headerData.filter,
      pageNumber: this.listParameters.pageNumber,
      pageSize: this.listParameters.pageSize,
      sortBy: onLoad ? this.listParameters.sortBy : '',
      sortOrder: onLoad ? this.listParameters.sortOrder : true,
    };
    this.isRowHighlighted = onLoad;

    this.triggerDataFromHeader.emit(params);
  }

  onSearch(): void {
    this.headerData.search = this.searchText;

    this.dataChangeFromHeader(false);
  }

  onSearchAll(): void {
    if (this.searchText === '') {
      this.onSearch();
    }
  }

  triggerDateChange(data: any): void {
    if (data.value === '-1') {
      this.headerData.startDate = '';
      this.headerData.endDate = '';
      this.isTrialBalanceImported = false;
      this.isAccountProductionTrialBalance = false;
      this.isManualTrialBalance=false;
      this.accoutingPeriodId = Guid.EMPTY as unknown as Guid;
    } else {
      this.headerData.startDate = data.startDate;
      this.headerData.endDate = data.endDate;
      this.isTrialBalanceImported = data.isTrialBalanceImported;
      this.isAccountProductionTrialBalance =
        data.isAccountProductionTrialBalance;
        this.isManualTrialBalance =
        data.isManualTrialBalance;
      this.accoutingPeriodId = data.accountingPeriodId;
    }

    this.dataChangeFromHeader(false);
  }

  activityChange(value: any): void {
    this.selectedActivity = value ?? '';
    this.headerData.activityId = value ? value : null;
    this.listParameters.pageNumber = 1;
    this.dataChangeFromHeader(false);
  }

  import(): void {
    const selectedPeriod = this.periodicDateList?.find(
      (x) => x.id === this.accoutingPeriodId
    );

    if (selectedPeriod?.isLocked) {
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.accountingPeriodLocked
      );
      return;
    }
    if (this.moduleId !== Modules.BankDashboard) {
      const params = { moduleId: btoa(this.moduleId.toString()) };
      this.router.navigate([RoutingPath.Import, params]);
    } else {
      const params = { customId: btoa(this.customId.toString()) };
      this.router.navigate([RoutingPath.BankImport, params]);
    }
  }

  bankEntryClick(isBankEntry): void {
    const params = {
      customId: btoa(this.customId),
    };

    if (isBankEntry) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = params;
      this.dialog
        .open(QuickJournalComponent, dialogConfig)
        .afterClosed()
        .subscribe((id) => {
          if (!this.commonService.isEmpty(id)) {
            const params = {
              customId: this.customId,
            };
            this.triggerQuickAdd.emit(params);
          }
        });
    } else {
      this.router.navigate([RoutingPath.CashCoding, params]);
    }
  }

  export(format: number, isPrint: boolean): void {
    let totalRecordOfRecords = 0;
    if (this.moduleId === Modules.BankDashboard) {
      this.totalBankOverviewRecord$.subscribe((x) => {
        totalRecordOfRecords = x;
      });
    } else {
      this.totalRecord$.subscribe((x) => {
        totalRecordOfRecords = x;
      });
    }

    if (
      format === ExportType.ExportAsExcelOutstandingBal ||
      format === ExportType.ExportAsCSVOutstandingBal ||
      format === ExportType.ExportAsPDFOutstandingBal
    ) {
      this.listParameters.filter = 0;
    } else if (
      (format === ExportType.Excel ||
        format === ExportType.CSV ||
        format === ExportType.PDF) &&
      (this.moduleId === Modules.Debtors || this.moduleId === Modules.Creditors)
    ) {
      this.listParameters.filter = -1;
    }

    if (format === ExportType.ExportAsExcelOutstandingBal) {
      format = ExportType.Excel;
    } else if (format === ExportType.ExportAsCSVOutstandingBal) {
      format = ExportType.CSV;
    } else if (format === ExportType.ExportAsPDFOutstandingBal) {
      format = ExportType.PDF;
    }

    if (totalRecordOfRecords > 0) {
      const params = {
        startDate: this.headerData.startDate,
        endDate: this.headerData.endDate,
        filter: this.listParameters.filter,
        search: this.headerData.search,
        moduleId: this.headerData.moduleId,
        subModuleId: this.headerData.subModuleId,
        pageNumber: this.listParameters.pageNumber,
        pageSize: totalRecordOfRecords,
        format: format,
        isPrint: isPrint,
        sortBy: this.listParameters.sortBy,
        sortOrder: this.listParameters.sortOrder,
      };
      this.triggerDataFromHeader.emit(params);
    } else {
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.noDataToExport
      );
    }
  }

  setDataFortheHeaderParamters(headerName: any, value: any): void {
    if (headerName === HeaderFilter.Filter) {
      this.headerData.filter = value;
    }
    if (headerName === HeaderFilter.Module) {
      this.headerData.moduleId = value;
    }
    if (headerName === HeaderFilter.SubModule) {
      this.headerData.subModuleId = value;
    }
  }

  onDropdownChange(headerName: any, value: any, onLoad: boolean): void {
    this.setDataFortheHeaderParamters(headerName, value);

    this.listParameters.pageNumber = 1;
    this.dataChangeFromHeader(onLoad);
  }

  onEditClick(isEdit:boolean): void {
    if (this.moduleId === Modules.TrialBalance) {
      this.router.navigate([RoutingPath.EditTrialBalance]);
    }
    if (this.moduleId === Modules.AccountProductionTrialBalance) {
      if(isEdit){
        this.router.navigate([RoutingPath.EditAccountProductionTrialBalance]);
      }else{
        this.router.navigate([RoutingPath.ManualAccountProductionTrialBalance]);
      }
      
    }
  }

  sendMail(moduleId: any): void {
    this.setSendMailParameters(4);
    this.dialog
      .open(ShareComponent, {
        data: {
          moduleId: moduleId,
          sendMailParamsRequest: this.sendMailParamsRequest,
        },
      })
      .afterClosed()
      .subscribe();
  }

  setSendMailParameters(format: number): void {
    const params = {
      startDate:
        this.datepipe
          .transform(this.listParameters.startDate, 'yyyy-MM-dd')
          ?.toString() ?? null,
      endDate:
        this.datepipe
          .transform(this.listParameters.endDate, 'yyyy-MM-dd')
          ?.toString() ?? null,
      filter: this.listParameters.filter,
      search: this.headerData.search,
      moduleId: this.headerData.moduleId ?? (Guid.EMPTY as unknown as Guid),
      subModuleId: this.headerData.subModuleId,
      pageNumber: this.listParameters.pageNumber,
      pageSize: 2147483647,
      format: format,
      isPrint: false,
      sortBy: this.listParameters.sortBy,
      sortOrder: this.listParameters.sortOrder,
    };
    this.sendMailParamsRequest = params;
  }

  manualImportClick(): void {
    if (this.moduleId === Modules.BankDashboard) {
      const params = { customId: btoa(this.customId?.toString()) };
      this.router.navigate([RoutingPath.BankManualImport, params]);
    }
  }

  addGroupNameToListModels(data: any[]): any[] {
    let result: any = [];

    data.forEach((group) => {
      group.listModels.forEach((listModel) => {
        let listModelWithGroup = {
          ...listModel,
          groupName: group.groupName,
        } as any;
        result.push(listModelWithGroup);
      });
    });

    return result;
  }

  showJurnals() : void {
    this.router.navigate([RoutingPath.Jurnals]);
  }

  redirect():void{
    const selectedPeriod = this.periodicDateList?.find(
      (x) => x.id === this.accoutingPeriodId
    );

    if (selectedPeriod?.isLocked) {
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.accountingPeriodLocked
      );
      return;
    }
    if(this.isManualTrialBalance){
       this.showJurnals();
    }else{
    this.onEditClick(false);
    }
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {disableClose: true,});
  }
}
